import { render, staticRenderFns } from "./KnowledgeBases.vue?vue&type=template&id=179d2c32&scoped=true"
import script from "./KnowledgeBases.vue?vue&type=script&lang=js"
export * from "./KnowledgeBases.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBases.vue?vue&type=style&index=0&id=179d2c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d2c32",
  null
  
)

export default component.exports